/* eslint-disable */
import React, { useState, useEffect, useMemo, useRef } from "react";
import PropTypes from "prop-types";
import { Transition } from "react-transition-group";
import { connect } from "react-redux";
import Preloader from "../../UI/Preloader/Preloader";
// --- Import hooks
import useMakeRequest from "../../../hooks/useMakeRequest";
import pixelEvent from "../../../hooks/pixelEvent";
// --- Import image
import SearchIcon from "../../../assets/images/search_icon.png";

import "./AutocompleteInput.sass";

// ---- Animation
const slide = {
  entering: { width: 0, overflow: "hidden" },
  entered: { width: "100%", transition: "all 800ms" },
  exiting: { width: "100%", overflow: "hidden" },
  exited: {
    width: 0,
    paddingLeft: 0,
    paddingRight: 0,
    transition: "all 800ms",
    overflow: "hidden",
  },
};

function AutocompleteInput({ userData, controler, action, showInput }) {
  const component = useRef();
  const [inputValue, setInputValue] = useState("");
  const [hintData, setHintData] = useState([]);
  const [displayInput, setDisplayInput] = useState(false);
  const [displayHint, setDisplayHint] = useState(false);
  const [error, setError] = useState();
  const [setParams, result, isLoading, hasError, requestError] =
    useMakeRequest();

  // --- Handle click outside of the conponent
  const handleClick = (e) => {
    if (component.current.contains(e.target)) {
      // inside click
      return;
    }
    // outside click
    setDisplayInput(false);
    setDisplayHint(false);
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClick);
    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, []);
  const handleShowInput = () => {
    setDisplayInput(!displayInput);
    setDisplayHint(false);
    pixelEvent({
      evt_src: "acct",
      evt_action: "show_search",
    });
  };
  // ---- Function on pressing Enter redirects the user
  const onEnterPress = (event) => {
    if (
      event.keyCode === 13 &&
      event.shiftKey === false &&
      hintData.length !== 0 &&
      !hasError
    ) {
      event.preventDefault();
      window.open(`${hintData[0].link}`);
    }
  };
  // ---- Function on pressing the Tab key fills the input with the first prompt
  const onTabPress = (event) => {
    if (
      event.keyCode === 9 &&
      event.shiftKey === false &&
      hintData.length !== 0 &&
      !hasError
    ) {
      setInputValue(hintData[0].title);
    }
  };
  // ----Function to filter hint if query data exists
  function filderHints(value, data, isError) {
    if (data !== null && data.length !== 0 && !isError && value === "") {
      setHintData(data.slice(0, 4));
      setDisplayHint(false);
    } else if (data !== null && data.length !== 0 && !isError && value !== "") {
      setHintData(
        data.filter((item) =>
          item.title.toLowerCase().includes(value.toLowerCase())
        )
      );
      setDisplayHint(true);
    }
  }
  // ---- Function for requesting a hint
  function makeRequestForHint(value, hints) {
    if (hints.length === 0) {
      setParams({
        c: controler,
        a: action,
        p: { q: value },
      });
    }
  }
  // ---- Function to display error
  function showError(data, isError, err) {
    if (data !== null && data.length === 0) {
      setError("Nothing found");
    } else if (isError) {
      setError(err);
      // setDisplayHint(true);
    } else {
      setError(undefined);
    }
  }
  // ---- Clear input value if input is not visible
  useEffect(() => {
    if (displayInput === false) {
      setInputValue("");
      setError(undefined);
    }
  }, [displayInput]);
  // ---- Make a request on every input change
  useEffect(() => {
    makeRequestForHint(inputValue, hintData);
  }, [inputValue, hintData]);
  // ---- Show error if there is an error
  useMemo(() => {
    showError(result, hasError, requestError);
  }, [result, hasError, requestError]);
  // ---- Set hint on every query data change
  useMemo(() => {
    filderHints(inputValue, result, hasError);
  }, [inputValue, result, hasError]);
  return (
    <article ref={component} className="search">
      <Transition in={displayInput || showInput} timeout={0} mountOnEnter>
        {(state) => (
          <div className="search__input-wrapper" style={{ ...slide[state] }}>
            <input
              type="text"
              className="search__input"
              value={inputValue}
              onFocus={() => setDisplayHint(true)}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyDown={(e) => {
                onEnterPress(e);
                onTabPress(e);
              }}
            />
            {isLoading && (
              <div className="search__loading-wrapper">
                <Preloader color="#fff" width="15px" thickness="14px" />
              </div>
            )}
            {hintData && displayHint && (
              <ul className="search__hints-list">
                {hintData.map((item, i) => {
                  return (
                    <li key={i} className="search__hint">
                      {hasError ? (
                        <span className="search__error">{item.title}</span>
                      ) : (
                        <a
                          rel="noreferrer"
                          target="_blank"
                          href={`${item.link}${
                            userData ? `&guid=${userData.guid}` : ""
                          }`}
                          className="search__hint-link"
                        >
                          {item.title}
                        </a>
                      )}
                    </li>
                  );
                })}
              </ul>
            )}
            {error && displayHint && (
              <ul className="search__hints-list">
                <li className="search__hint">
                  <span className="search__error">{error}</span>
                </li>
              </ul>
            )}
          </div>
        )}
      </Transition>
      <button onClick={handleShowInput} className="search__btn">
        <img src={SearchIcon} alt="" />
      </button>
    </article>
  );
}

const mapStateToProps = (state) => ({
  userData: state.userDataStore.userData,
});

const mapDispatchToProps = {};

AutocompleteInput.propTypes = {
  userData: PropTypes.objectOf(PropTypes.string),
  controler: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  showInput: PropTypes.bool,
};
AutocompleteInput.defaultProps = {
  userData: null,
  showInput: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(AutocompleteInput);
